import { Action, createReducer, on } from '@ngrx/store';
import * as action from '../actions';
import { IBusinessPaymentRunDetailProducts } from '../dto/business-payment-run-detail-products.dto';

export const businessPaymentRunDetailProductFeatureKey = 'businessPaymentRunDetailProduct';

export interface BusinessPaymentRunDetailProductState {
  loadBusinessPaymentRunDetailProducts: any;
  loadBusinessPaymentRunDetailProductsSuccess: IBusinessPaymentRunDetailProducts[];
}

export const initialState: BusinessPaymentRunDetailProductState = {
  loadBusinessPaymentRunDetailProducts: undefined,
  loadBusinessPaymentRunDetailProductsSuccess: undefined
};

export const reducer = createReducer(
  initialState,
  on(action.loadBusinessPaymentRunDetailProducts, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailProducts: action.request
  })),
  on(action.loadBusinessPaymentRunDetailProductsSuccess, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailProductsSuccess: action.response
  }))
);
export const getBusinessPaymentRunDetailProducts = (state: BusinessPaymentRunDetailProductState) =>
  state.loadBusinessPaymentRunDetailProductsSuccess;
